import React from 'react'
import { SubmitErrorListener } from '@components/ui/SubmitErrorListener/SubmitErrorListener'
import { ClaimAcceptedListener } from '@components/ui/ClaimAcceptedListener'
import { AppHOC, AppProps } from './AppHOC'

const CtaContainer = React.lazy(() => import('@components/CTA/CtaContainer'))

export const CtaApp: React.FC<AppProps> = props => {
  const { widgetContext } = props
  return (
    <AppHOC widgetContext={widgetContext}>
      <CtaContainer />
      <SubmitErrorListener />
      <ClaimAcceptedListener />
    </AppHOC>
  )
}
